module.exports = __webpack_public_path__ + "img/hoplucpostlogo.8130f39c.png";